module.exports = __webpack_public_path__ + "img/eq-boots.2c87c4b0.png";